import * as DataInformaciones from "./DataInformaciones.js";
import * as TipoObjeto from "../../constantes/TipoObjeto.js";

export const DeleteItem = async (idPadre, idItem) => {
  return await DataInformaciones.DeleteItem(idPadre, idItem);
};

export const GetItem = async (idPadre, idItem) => {
  return DataInformaciones.GetItem(idPadre, idItem);
}

export const GetListaItems = async (idPadre) => {
  return DataInformaciones.GetListaItems("personas", idPadre);
}

export const PostItem = async (idPadre, datosItem) => {
  return await DataInformaciones.PostItem(TipoObjeto.PERSONA, idPadre, datosItem);
};

export const PutItem = async (idPadre, datosItem) => {
  return await DataInformaciones.PutItem(TipoObjeto.PERSONA, idPadre, datosItem);
};
